<template>
  <v-text-field outlined v-on="$listeners" class="pr-1" v-model="valueComputed">
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name"/>
    </template>
  </v-text-field>
</template>

<script>

import {computed} from '@vue/composition-api'

export default {
  name: 'TextFieldCustom',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  setup(props, {emit}){
    const valueComputed = computed({
      get: () => props.value,
      set: (value) => {
        emit('input', value)
      }
    })
    return {valueComputed}
  }
}
</script>

<style scoped lang="scss">
.v-input {
  position: relative;

  &.pr-1 {
    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      background-color: map-get($grey, 'lighten-4');
      content: '';
      width: 8px;
      height: 1px;
    }
  }
}
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-input {
  .v-input__prepend-outer {
    position: relative;

    &::after {
      position: absolute;
      left: 0;
      right: 8px;
      bottom: 0;
      background-color: map-get($grey, 'lighten-4');
      content: '';
      height: 1px;
    }
  }

  .v-input__control {
    position: relative;
    z-index: 1;
  }
}
</style>
